import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { SideNavItemProps } from '../components/layout/components/sideNav/components'
import i18n from '../i18n'
import { MenuItem } from '../model/RBAC'
import { Pages, Routes } from '../model/RBAC/constants'

export const mapMenuItems = (items: MenuItem[] | undefined): SideNavItemProps[] => {
  if (items === undefined) {
    return []
  }

  let parentItems = items.filter(
    x => x.idParent === null && Routes.get(Pages[x.title]) !== undefined
  )

  return parentItems.map((item: MenuItem) => {
    let sideNavItem = mapMenuItemToSideNavItemItem(item)
    const children = items.filter(x => x.idParent === item.id && Routes.get(Pages[x.title]) !== undefined)
    sideNavItem.items = mapMenuItemsToSideNavItemItems(children)

    return sideNavItem
  })
}

const mapMenuItemsToSideNavItemItems = (items: MenuItem[]): SideNavItemProps[] => {
  return items && items.map(mapMenuItemToSideNavItemItem)
}

const mapMenuItemToSideNavItemItem = (item: MenuItem): SideNavItemProps => {
  return (
    item && {
      name: i18n.t(item.title),
      link: Routes.get(Pages[item.title])?.path,
      icon: Routes.get(Pages[item.title])?.icon as IconProp,
      sideNavOpen: false
    }
  )
}
